import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DocumentListeAgentPage from "./pages/DocumentListeAgentPage";
import DocumentListeTechnicienPage from "./pages/DocumentListeTechnicienPage";
import UserListeAdminPage from "./pages/UserListeAdminPage";
import DocumentDetailsTechnicien from "./pages/DocumentDetailsTechnicien";
import UserFormulaireAdmin from "./pages/UserFormulaireAdmin"; 
import UserFormPage from "./pages/UserFormPage";
import CollectDataPage from "./pages/CollectDataPage";
import MapPage from "./pages/MapPage";
import PageFormGenerator from "./pages/PageFormGenerator";
import ProjectPage from "./pages/ProjectPage";
import OffrePage from "./pages/OffrePage";
import ListFormAdmin from "./pages/ListFormAdmin";
import OffreDetailsPage from "./pages/OffreDetailsPage";
import GestionMenuPage from "./pages/GestionMenuPage";
import GestionOffre from "./pages/GestionOffre";
import GestionProjet from "./pages/GestionProjet";
import EventPage from "./pages/EventPage";
import CalendarPage from "./pages/CalendarPage";
import IndicateurForm from "./pages/IndicateurForm";
import RapportPage from "./pages/RapportPage";
import IndicateurListPage from "./pages/IndicateurListPage";
import RapportBuilderPage from "./pages/RapportBuilderPage";
import RapportModelesPage from "./pages/RapportModelesPage";
import RapportFromModelePage  from "./pages/RapportFromModelePage";
import RapportsGeneresPage from "./pages/RapportsGeneresPage";
import RapportDetailPage from "./pages/RapportDetailPage";


const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/agent" element={<DocumentListeAgentPage />} />
      <Route path="/technicien" element={<DocumentListeTechnicienPage />} />
      <Route path="/admin" element={<UserListeAdminPage />} />
      <Route path="/admin/create-user" element={<UserFormulaireAdmin />} /> 
      <Route path="/admin/form-list" element={<ListFormAdmin/>} />
      <Route path="/admin/form-create" element={<PageFormGenerator/>} />
      <Route path="/admin/update-user/:id" element={<UserFormPage/>} /> 
      <Route path="/admin/menu" element={<GestionMenuPage/>} />
      <Route path="/admin/offre" element={<GestionOffre />} />
      <Route path="/admin/projet" element={<GestionProjet />} />
      <Route path="/details/:id" element={<DocumentDetailsTechnicien />} />
      <Route path="/agent/collect" element={<CollectDataPage />} />
      <Route path="/" element={<MapPage />} />
      <Route path="/admin/dynamic-form" element={<PageFormGenerator />} />
      <Route path="/project" element={<ProjectPage />} />
      <Route path="/offre" element={<OffrePage />} />
      <Route path="/offre/:id" element={<OffreDetailsPage />} />
      <Route path="/calendar" element={<CalendarPage />} />
      <Route path="/event" element={<EventPage />} />
      <Route path="/create-indicateur" element={<IndicateurForm/>}/>
      <Route path="/create-rapport" element={<RapportPage/>}/>
      <Route path="/sap" element={<IndicateurListPage/>}/>
      <Route path="/rapport-builder" element={<RapportBuilderPage />} />
      <Route path="/rapport-modeles" element={<RapportModelesPage />} />
      <Route path="/rapport-from-modele" element={<RapportFromModelePage />} />
      <Route path="/rapport-list" element={<RapportsGeneresPage />} />
      <Route path="/rapport-detail" element={<RapportDetailPage />} />
    </Routes>
  );
};

export default AppRoutes;
